import { render } from "./ThinkTankPostWithComment.vue?vue&type=template&id=efc10ef2&scoped=true"
import script from "./ThinkTankPostWithComment.vue?vue&type=script&lang=js"
export * from "./ThinkTankPostWithComment.vue?vue&type=script&lang=js"

import "./ThinkTankPostWithComment.vue?vue&type=style&index=0&id=efc10ef2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-efc10ef2"

export default script